<template>
    <div>
        <button class="mt-12" data-toggle="modal" data-target="#editProfileModalCenter">Edit Profile</button>


        <!-- Modal -->
        <div class="modal fade adminprofile-editmodal" id="editProfileModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                
                <div class="modal-body">
                    <div class="edit-profile-head">
                        <h3>Edit Profile</h3>
                        <p data-dismiss="modal" aria-label="Close"><v-icon color="#333333" size="25px">mdi-close</v-icon></p>
                    </div>
                    <v-row class="mt-8 px-10">
                        <v-col md="4" sm="4" cols="12">
                            <div class="profile-pic-hld">
                                <div class="profile-pic-inner">
                                    <img src="../assets/Images/avatar.jpg" alt="DG"/>
                                </div>
                                <div class="profile-upload-sec">
                                    <v-icon dark icon color="#ffffff">mdi-pencil-outline</v-icon>
                                </div>
                            </div>
                            <div class="admin-edit-social-links"></div>
                        </v-col>
                        <v-col md="8" sm="8" cols="12">
                          <div class="edit-profile-prof-details">
                            <v-row>
                              <v-col md="6" sm="6" cols="12">
                                <div class="name-edit-wrap">
                                  <label>First Name</label>
                                  <div class="position-relative">
                                    <input type="text" name="" id="" value="Aiden"/>
                                    <div class="edit-bio-button edit-button-names">
                                      <v-icon dark icon color="#959595">mdi-pencil-outline</v-icon>
                                    </div>
                                  </div>
                                </div>
                              </v-col>

                              <v-col md="6" sm="6" cols="12">
                                <div class="name-edit-wrap">
                                  <label>Last Name</label>
                                  <div class="position-relative">
                                    <input type="text" name="" id="" value="Smith"/>
                                    <div class="edit-bio-button edit-button-names">
                                      <v-icon dark icon color="#959595">mdi-pencil-outline</v-icon>
                                    </div>
                                  </div>
                                </div>
                              </v-col>


                              <v-col md="6" sm="6" cols="12">
                                <div class="name-edit-wrap">
                                  <label>Email</label>
                                  <div class="position-relative">
                                    <input type="email" name="" id="" value="aiden_smith@ymail.com"/>
                                  </div>
                                </div>
                              </v-col>
                              <v-col md="6" sm="6" cols="12">
                                <div class="name-edit-wrap">
                                  <label>Mobile</label>
                                  <div class="position-relative">
                                    <input type="text" name="" id="" value="+1 785-515-693"/>
                                    <div class="edit-bio-button edit-button-names">
                                      <v-icon dark icon color="#959595">mdi-pencil-outline</v-icon>
                                    </div>
                                  </div>
                                </div>
                              </v-col>

                              <v-col md="6" sm="6" cols="12">
                                <div class="name-edit-wrap">
                                  <label>Company</label>
                                  <div class="position-relative">
                                    <input type="text" name="" id="" value="Premier IT Solutions"/>
                                    <div class="edit-bio-button edit-button-names">
                                      <v-icon dark icon color="#959595">mdi-pencil-outline</v-icon>
                                    </div>
                                  </div>
                                </div>
                              </v-col>

                              <v-col md="6" sm="6" cols="12">
                                <div class="name-edit-wrap">
                                  <label>Designation</label>
                                  <div class="position-relative">
                                    <input type="text" name="" id="" value="Project Manager"/>
                                    <div class="edit-bio-button edit-button-names">
                                      <v-icon dark icon color="#959595">mdi-pencil-outline</v-icon>
                                    </div>
                                  </div>
                                </div>
                              </v-col>
                              
                            </v-row>
                            <div class="edit-profile-bio-wrap">
                              <label>Mini Bio</label>
                              <div class="edit-profile-bio-inner">
                                <textarea cols="20" rows="10" name="" id="" value=""></textarea>
                                <div class="edit-bio-button">
                                    <v-icon dark icon color="#ffffff">mdi-pencil-outline</v-icon>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-col>
                    </v-row>
                    <div class="save-edit-profile">
                      <v-btn outlined color="#333" width="120px" class="mr-3" data-dismiss="modal">Cancel</v-btn>
                      <v-btn dark color="#1a73e8" width="120px">Save</v-btn>
                    </div>
                </div>
                
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import HelloWorld from "@/components/HelloWorld.vue";
// import Router from "vue-router";
// import firebase from "firebase";
import APIs from "@/components/APIInit";
import db from "../components/firebaseInit";
import firebase from "firebase";
import store from "../store";
import router from "../router";
import jQuery from "jquery";
let $ = jQuery;
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import axios from "axios";
import { bus } from "@/main";
import jwt_decode from "jwt-decode";

Vue.use(VueMoment, {
  moment,
});

var self;
var eventCloneProgress;
export default {
  data() {
    return {
      tempAdminEvent: null,
      uid: "",
      APIs: APIs,
      noEventLink: "https://e2m.live/",
      EventsData: [],
      clientID: "", //this.$store.getters.getClient[0].id,
      BannerURL: "",
      noEventMessage: false,
      isMobileSearch: false,
      mobileBanner: "",
      desktopBanner: "",
      ShowCreateEventButton: false,
      searchText: "",
      filterDateFrom: "",
      filterDateTo: "",
      filterStatus: "",
      tab: null,
      switch1: true,
      radioGroup: 1,
      items: ["Event Admin", "Analytics"],
      //currentTab: "Overview",
    };
  },
  computed: {
    hasSession() {
      if (self.uid) {
        return true;
      } else {
        return false;
      }
    },
    SearchEventsData() {
      var result = [];
      var searchText = (self.searchText ? self.searchText : "")
        .trim()
        .toLowerCase();
      if (!searchText) {
        result = self.EventsData.filter(function () {
          return true;
        });
      } else {
        result = self.EventsData.filter(function (item) {
          if (item.Name.toLowerCase().includes(searchText.toLowerCase())) {
            return true;
          }
        });
      }
      if (self.filterDateFrom) {
        let filterDateFrom = new Date(self.filterDateFrom);
        let startSeconds = parseInt(filterDateFrom.getTime() / 1000);
        result = result.filter(function (item) {
          if (startSeconds < item.EventEndDateS) {
            return true;
          }
        });
      }
      if (self.filterDateTo) {
        let filterDateTo = new Date(self.filterDateTo);
        filterDateTo.setDate(filterDateTo.getDate() + 1);
        let endSeconds = parseInt(filterDateTo.getTime() / 1000);
        result = result.filter(function (item) {
          if (endSeconds > item.EventEndDateS) {
            return true;
          }
        });
      }
      if (self.filterStatus) {
        var filterStatus = self.filterStatus == "true" ? true : false;
        result = result.filter(function (item) {
          return item.IsPublished == filterStatus;
        });
      }
      return result;
    },
  },
  watch: {
    //searchText(val) {
    //  alert(val);
    //},
  },
  beforeCreate() {
    // setTimeout(() => {
    //   setTimeout(() => {
    //     setTimeout(() => {
    //       $("#app").addClass("full-screen");
    //     }, 100);
    //     $("#app").addClass("full-screen");
    //   }, 100);
    //   $("#app").addClass("full-screen");
    // }, 100);
    // $("#app").addClass("full-screen");
  },
  created() {
    self = this;
    self.uid = self.getSessionUserId();
    self.initScreen();
    $(window).resize(function () {
      self.initScreen();
    });

    let urlParams = String(window.location.href).split("#");
    if (
      urlParams.length > 1 &&
      urlParams[1].toLowerCase() == "managemyevents"
    ) {
      self.tab = "ManageMyEvents";
    }
  },
  mounted() {
    self.tempAdminEvent = self.$store.getters.getTempAdminEvent;
    // if (!self.tempAdminEvent) {
    //   self.tempAdminEvent = new Object();
    // }
    debugger;
    console.log("tempAdminEvent========", self.tempAdminEvent);
    if (self.tempAdminEvent && self.tempAdminEvent.DocPath != null) {
      //self.tempAdminEvent.Status = "In Progress";
      if (eventCloneProgress) {
        eventCloneProgress();
        eventCloneProgress = undefined;
      }
      eventCloneProgress = db
        .doc(self.tempAdminEvent.DocPath)
        .onSnapshot((doc) => {
          //alert("in");
          debugger;
          if (doc.exists) {
            let data = doc.data();
            self.tempAdminEvent.StatusId = parseInt(data.status);
            if (isNaN(self.tempAdminEvent.StatusId)) {
              self.tempAdminEvent.StatusId = 0;
            }
            self.tempAdminEvent.Status = data.msg;
            //console.log("data========", data);
            if (self.tempAdminEvent.StatusId == 200) {
              if (eventCloneProgress) {
                eventCloneProgress();
                eventCloneProgress = undefined;
              }
              self.tempAdminEvent = null;
              self.commit("setTempAdminEvent", {});
              self.refreshIdToken();
            } else if (self.tempAdminEvent.StatusId < 0) {
              self.showSnackbar(
                "Something went wrong. Click Retry to create the event",
                "error",
                "top"
              );
            }
          }
        });
    }

    self.noEventLink = self.$t("client.registerRoute");
    self.clientID = self.$route.query.c;
    //this.clientID = self.$route.params.c;
    /* $("#alleventSec").css("background-size", "cover");
    $("#alleventSec").css("background-color", "none");
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    $("#alleventSec").css(
      "background-image",
      "url(" + obj.branding[0].bg2 + ")"
    );
    $("#alleventSec").css("background-size", "100%");
    //alert(obj.Branding[0].banner)
    $("#imgBanner").attr("src", obj.branding[0].banner);

    $(".clsDynamicColor").css("color", obj.branding[0].bodyTextColor);*/
    //debugger;
    // $("#topmenu").hide();
    // $("#leftmenu").hide();
    // var obj = JSON.parse(window.localStorage.getItem("my-app"));
    // this.BannerURL = obj.branding[0].banner;
    /*+++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
    //  self.tid =
    //   this.$route.params.tid == undefined ? "" : this.$route.params.tid;

    //-------------------------GEt client id by host---------------------------------------
    //self.clientID = this.$route.params.c;
    const HOSTURL = process.env.VUE_APP_LOCALHOST_URL_EDU;
    if (location.host.toLowerCase().indexOf("localhost") >= 0) {
      //this.result = "uatonair.e2m.live";
      //self.hostName = "onair.e2m.live";
      self.hostName = HOSTURL ? HOSTURL : "uatonair.e2m.live";
      // self.hostName = "uatbni.e2m.live";
      // this.result = "tci.e2m.live";
      //this.result = "uatcapitalgroup.e2m.live";
    } else {
      self.hostName = HOSTURL ? HOSTURL : location.host;
      //self.hostName = location.host;
    }
    var path;
    //console.log(self.hostName);
    if (this.hostName.toLowerCase().indexOf("uat") > -1) {
      path = "https://resources.e2m.live/uate2monair.appspot.com/";
    } else {
      path = APIs.googleSoragePath;
    }
    axios
      .get(
        path + "OA_UAT%2FClients%2FHosts%2F" + this.hostName + ".json?alt=media"
      )
      .then((res) => {
        if (res && res.data) {
          bus.$emit("EnableHelpChat", "Event", res.data.ClientId);
        }
        self.clientID = res.data.ClientId;
        //self.clientName = res.data.ClientName;
        document.title = res.data.ClientName;
        if (
          res.data.EventListAssets &&
          res.data.EventListAssets.banner2048x88
        ) {
          self.desktopBanner = res.data.EventListAssets.banner2048x88;
        }
        if (
          res.data.EventListAssets &&
          res.data.EventListAssets.banner750x103
        ) {
          self.mobileBanner = res.data.EventListAssets.banner750x103;
        }
        self.initScreen();
        self.EventsData = [];
        self.displayEvents();
      });
  },
  methods: {
    enterInsideEvent(event) {
      self.ChangeCurrentEvent(event.clientID, event.id);
    },
    ChangeTab(tab) {
      self.tab = tab;
      debugger;
      location.hash = tab;
      //router.push("")
    },
    Logout() {
      bus.$emit("clearState");
    },
    initScreen() {
      if (window.innerWidth > 768) {
        self.isMobileSearch = false;
        self.BannerURL = self.desktopBanner;
      } else {
        self.isMobileSearch = true;
        self.BannerURL = self.mobileBanner;
      }
    },
    stopShimmer() {
      $(".shimmer-effect").css("display", "none");
    },
    mob_elist_search() {
      $("#mob_ev_search").css("display", "block");
      $(".mob_search_button").css("opacity", "0 ");
    },
    DisplayCreateEventPopup() {
      //$("#SignUpModal").modal("show");
    },
    refreshIdToken() {
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          firebase
            .auth()
            .currentUser.getIdToken(true)
            .then((idToken) => {
              var decoded = jwt_decode(idToken);
              document.cookie = "token=";
              document.cookie = "token=" + idToken + ";";
              store.commit("setCurrentLoggedInTime", decoded.exp);
              store.commit("addToken", idToken);
              self.displayEvents();
            })
            .catch((err) => {
              console.log("token set error==", err);
            });
        }
      });
    },
    displayEvents() {
      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };
      axios
        .get(self.APIs.UserEvent, {
          headers: headers,
        })
        .then((response) => {
          self.EventsData = [];
          var clients = response.data.result;
          var AdminRoles = [];
          if (response.data.profile && response.data.profile.AdminRoles) {
            store.commit("setAdminRoles", response.data.profile.AdminRoles);
            AdminRoles = response.data.profile.AdminRoles;
            // ClientId: "C1591205467009";
            // EventId: "E1637219036051";
            // RoleID: 3;
            // RoleName: "EventAdmin";
          }
          //debugger;
          for (var n = 0; n < clients.length; n++) {
            var client = clients[n];
            var events = client.events;
            var currentTime = parseInt(new Date().getTime() / 1000);
            for (var i = 0; i < events.length; i++) {
              var event = events[i];

              var dtstrt = parseInt(
                new Date(event.EventStartDateTime).getTime() / 1000
              );
              var dtEnd = parseInt(
                new Date(event.EventEndDateTime).getTime() / 1000
              );

              if (dtstrt > currentTime) {
                event.status = "upcoming";
              } else if (dtstrt <= currentTime && dtEnd >= currentTime) {
                if (!event.IsPublished) {
                  event.status = "underreview";
                } else {
                  event.status = "live";
                }
              } else {
                event.status = "ended";
              }

              var adminEvents = AdminRoles.filter(function (item) {
                return (
                  item.ClientId == event.ClientId &&
                  item.EventId == event.EventId
                );
              });

              if (adminEvents.length == 0) {
                continue;
              }
              let startTime = event.EventStartDateTime.substring(11, 16);
              let endTime = event.EventEndDateTime.substring(11, 16);

              self.EventsData.push({
                id: event.EventId,
                Name: event.EventFullName,
                EventLogo: self.getCDNUrl(event.EventLogo),
                EventStartDate: event.EventStartDate,
                EventEndDate: event.EventEndDate,
                EventCollectionName: event.EventCollectionName,
                EventTypeId: event.EventTypeId,
                EventTimezone: moment.tz.guess(), // data.TimeZone,
                EventStartDateS: event.EventStartDateTimestamp,
                EventEndDateS: event.EventEndtDateTimestamp,
                EventNewStartTime: self.SetTimeByZone(
                  moment(event.EventStartDate, ["DD-MM-YYYY"]).format(
                    "MMM DD, YYYY"
                  ) +
                    " " +
                    startTime,
                  moment.tz.guess()
                ),
                EventStartDateString:
                  moment(event.EventStartDate, ["DD-MM-YYYY"]).format(
                    "MMM DD, YYYY"
                  ) +
                  " " +
                  startTime, //self.formatDate(data.EventStartDate),
                EventEndDateString:
                  moment(event.EventEndDate, ["DD-MM-YYYY"]).format(
                    "MMM DD, YYYY"
                  ) +
                  " " +
                  endTime,
                EventNewEndTime: self.SetTimeByZone(
                  moment(event.EventEndDate, ["DD-MM-YYYY"]).format(
                    "MMM DD, YYYY"
                  ) +
                    " " +
                    endTime,
                  moment.tz.guess()
                ),
                IsPublished: event.IsPublished,
                StatusClass: event.IsPublished ? "" : "event-unpublished",
                status: event.status,
                clientID: event.ClientId,
                eventDefaultSessionPage: event.DefaultSessionPath
                  ? event.DefaultSessionPath
                  : "",
                DefaultLanguage:
                  event.DefaultLanguage === undefined
                    ? "English"
                    : event.DefaultLanguage,
              });
            }
          }
          self.refreshToken(response.data.customToken);
        })
        .catch((error) => {
          console.log(error);
        });
      // if (self.tabclickflag != true) {
      //   if (self.liveflag <= 0) {
      //     self.fliterflag = 2;
      //     $("#aEndedtab").removeClass("active");
      //     $("#aLivetab").removeClass("active");
      //     $("#aunderreviewtab").addClass("active");
      //     $("#aAlltab").removeClass("active");
      //     if (self.UnderReviewFlag <= 0 && self.liveflag <= 0) {
      //       self.fliterflag = 0;
      //       $("#aEndedtab").addClass("active");
      //       $("#aLivetab").removeClass("active");
      //       $("#aunderreviewtab").removeClass("active");
      //       $("#aAlltab").removeClass("active");

      //       if (
      //         self.Pastflag <= 0 &&
      //         self.UnderReviewFlag <= 0 &&
      //         self.liveflag <= 0
      //       ) {
      //         self.fliterflag = 3;
      //         $("#aEndedtab").removeClass("active");
      //         $("#aLivetab").removeClass("active");
      //         $("#aunderreviewtab").removeClass("active");
      //         $("#aAlltab").addClass("active");
      //       }
      //     }
      //   }
      // }

      // self.tabclickflag = false;
      // if (self.EventsData.length > 0) {
      //   self.eventCount = self.EventsData.length;
      //   if (self.fliterflag == 1) {
      //     debugger;
      //     self.EventsData = self.EventsData.filter(function (e) {
      //       return e.status == "live" || e.status == "upcoming";
      //     });
      //   } else if (self.fliterflag == 2) {
      //     self.EventsData = self.EventsData.filter(function (e) {
      //       return e.status == "underreview";
      //     });
      //   } else if (self.fliterflag == 0) {
      //     self.EventsData = self.EventsData.filter(function (e) {
      //       return e.status == "ended";
      //     });
      //   } else {
      //     debugger;
      //     self.EventsData = self.EventsData.filter(function (e) {
      //       return e.status.Contains(
      //         "live",
      //         "upcoming",
      //         "underreview",
      //         "ended"
      //       );
      //     });
      //   }
      // } else {
      //   self.eventCount = 0;
      // }
      //store.commit("addEventCount", self.eventCount);

      // if (self.sortOrder == "desc") {
      //   self.EventsData = self.EventsData.sort(function compare(a, b) {
      //     //parseInt(new Date(events[i].EventStartDateTime).getTime() / 1000)
      //     var dateA = parseInt(new Date(a.EventStartDateTime).getTime() / 1000);
      //     var dateB = parseInt(new Date(b.EventStartDateTime).getTime() / 1000);
      //     return dateB - dateA;
      //   });
      // } else {
      //   self.EventsData = self.EventsData.sort(function compare(a, b) {
      //     //parseInt(new Date(events[i].EventStartDateTime).getTime() / 1000)
      //     var dateA = parseInt(new Date(a.EventStartDateTime).getTime() / 1000);
      //     var dateB = parseInt(new Date(b.EventStartDateTime).getTime() / 1000);
      //     return dateA - dateB;
      //   });
      // }

      // if (self.eventCount == 1) {
      //   self.gotolobby = true;
      //   alert(self.$t("eventlist.routeMessageOnSingleEvent"));
      //   self.$router.push(eventDoc[1].DefaultLandingURL);
      //   self.goToEvent(eventDoc, eventDoc.DefaultSessionPath);
      // } else if (self.eventCount > 1) {
      //   self.gotolobby = false;
      // } else {
      //   //Not registered to any event
      //   //router.push({ name: "Login" });
      // }
    },
    refreshToken(token) {
      firebase
        .auth()
        .signInWithCustomToken(token)
        .then(function (res) {
          res.user
            .getIdToken(true)
            .then((idToken) => {
              var decoded = jwt_decode(idToken);
              document.cookie = "token=";
              document.cookie = "token=" + idToken + ";";
              self.$store.commit("addToken", idToken);
              self.$store.commit("setCurrentLoggedInTime", decoded.exp);
              document.cookie = "staysigned=";
              document.cookie = "userrole=";
              document.cookie = "userid=";
            })
            .catch((err) => {
              console.log("err=====", err);
            });
        })
        .catch(function (e) {
          console.log(e);
        });
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment.tz(strDateTime, timeZone).format("MMM DD, YYYY HH:mm");
      return date;
    },
    displayEventsReg() {
      //debugger;
      this.pageIndex++;
      var listRef = db
        .collection("OA_UAT/ClientList/Clients")
        .doc(self.clientID)
        .collection("Events");
      var cnt = 0;
      listRef
        //.where("IsPublished", "==", true)
        //.where("AllowRegistration", "==", true)
        .where("EventTypeId", "==", 2)
        //.get()
        .onSnapshot((querySnapshot) => {
          this.EventsData = [];
          debugger;
          if (querySnapshot.docs.length > 0) {
            querySnapshot.forEach((doc) => {
              cnt++;
              var data = doc.data();
              /* this.EventsData.push({
                id: doc.id,
                Name: data.EventFullName,
                EventLogo: data.EventLogo,
                EventStartDate: data.EventStartDate,
                EventEndDate: data.EventEndDate,
                EventCollectionName: data.EventCollectionName,
                EventTypeId: data.EventTypeId,
                EventTimezone: data.TimeZone,
                EventStartDateString: self.formatDate(data.EventStartDate),
                EventEndDateString: self.formatDate(data.EventEndDate)
              });*/
              var obj = new Object();
              obj.id = doc.id;
              obj.Name = data.EventFullName;
              obj.EventLogo = data.EventLogo;
              // obj.EventStartDate = data.EventStartDate;
              // obj.EventEndDate = data.EventEndDate;
              obj.EventCollectionName = data.EventCollectionName;
              obj.EventTypeId = data.EventTypeId;
              obj.EventTimezone = moment.tz.guess(); //data.TimeZone;
              //-------------------------------------------------------------------------------------------
              /* var mZone = moment.tz.guess();
              //obj.EventStartDateString = self.formatDate(data.EventStartDate);
              if (data.TimeZone != mZone) {
                var EventStartDate = self.formatDateTimeZoneWise(
                  data.EventStartDate
                );
                var momnt = moment.tz(EventStartDate, data.TimeZone);
                var strtDate = momnt.clone().tz(moment.tz.guess());
                obj.EventStartDateString = self.GetActualDateFormat(
                  strtDate.format()
                );
              } else {
                obj.EventStartDateString = self.formatDate(data.EventStartDate);
              }*/
              var dateFormat = require("dateformat");

              var dtstrt = new Date(data.EventStartDate.seconds * 1000);
              obj.EventStartDateString = dateFormat(dtstrt, "mmm dd, hh:MM TT");
              // obj.EventStartDateString = moment(dtstrt).format(
              //   " MMMM Do, h:mm a"
              // );
              //self.formatDate(data.EventStartDate);
              //------------------------------------------------------------------------------------------------
              /*if (data.TimeZone != mZone) {
                // obj.EventEndDateString = self.formatDate(data.EventEndDate);
                var EventEndDate = self.formatDateTimeZoneWise(
                  data.EventEndDate
                );
                var momnt2 = moment.tz(EventEndDate, data.TimeZone);
                var endDate = momnt2.clone().tz(moment.tz.guess());
                obj.EventEndDateString = self.GetActualDateFormat(
                  endDate.format()
                );
              } else {
                obj.EventEndDateString = self.formatDate(data.EventEndDate);
              }*/
              var dtend = new Date(data.EventEndDate.seconds * 1000);
              obj.EventEndDateString = dateFormat(dtend, "mmm dd, hh:MM TT"); // self.formatDate(data.EventEndDate);
              obj.EventStartDate = data.EventStartDate;
              obj.EventEndDate = data.EventEndDate;
              //------------------------------------------------------------------------------------------------
              self.EventsData.push(obj);
            });
            //debugger;
            self.noEventMessage = self.EventsData.length > 0 ? false : true;
            self.EventsData = self.EventsData.sort(function compare(a, b) {
              //debugger;
              //parseInt(new Date(events[i].EventStartDateTime).getTime() / 1000)
              var dateA = parseInt(
                new Date(a.EventStartDate.seconds * 1000).getTime() / 1000
              );
              var dateB = parseInt(
                new Date(b.EventStartDate.seconds * 1000).getTime() / 1000
              );
              return dateB - dateA;
            });
            if (cnt == 1) {
              //debugger;
              //router.push({
              //  path:
              //    "/event/" +
              //    this.EventsData[0].id +
              //    "/" +
              //    this.EventsData[0].Name
              //});
              router.push({
                path: "/event/" + this.EventsData[0].id,
              });
            }
          } else {
            self.noEventMessage = true;
          }
        });
      // .catch(error => {
      //   alert(error);
      //   // console.log("Error getting documents: ", error);
      // });
    },
    GetActualDateFormat: function (actualDt) {
      var dt = actualDt.split("T");
      var oDt = new Date(dt[0]).toDateString();

      var oTt = dt[1];
      var arrDate = oDt.split(" ");
      var accDate = arrDate[1] + " " + arrDate[2];

      var arrtime = oTt.split(":");
      var accTime = arrtime[0] + ":" + arrtime[1];

      var fullStartDate = accDate + " " + accTime;
      return fullStartDate;
    },
    formatDateTimeZoneWise: function (seconds) {
      var dateString = "";
      try {
        var dt = new Date(seconds.seconds * 1000);
        //debugger;

        var hrs = dt.getHours();
        hrs = hrs == 0 ? "00" : hrs;
        if (hrs != "00" && parseInt(hrs) < 10) {
          hrs = "0" + hrs;
        }

        var minutes = dt.getMinutes();
        minutes = minutes == 0 ? "00" : minutes;
        if (minutes != "00" && parseInt(minutes) < 10) {
          minutes = "0" + minutes;
        }

        var mnths = dt.getMonth();
        var accurateMon = mnths + 1;
        if (parseInt(accurateMon) < 10) {
          accurateMon = "0" + accurateMon;
        }

        dateString +=
          dt.getFullYear() +
          "-" +
          accurateMon +
          "-" +
          dt.getDate() +
          " " +
          hrs +
          ":" +
          minutes;

        //return dt.toLocaleDateString();
      } catch (ex) {
        console.log(ex);
      }
      return dateString;
    },
    goForLogin: function () {
      router.push({ name: "Login" });
    },
    selectEvent: function (eventId, evntName) {
      console.log("evntName:--- " + evntName);
      router.push({
        path: "/event/" + eventId,
      });
    },
    formatDate: function (seconds) {
      var dateString = "";
      //  alert(seconds);
      // if (seconds == 1594125120) {
      //   debugger;
      // }
      try {
        var dt = new Date(seconds.seconds * 1000);
        const monthNamesShort = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        var minutes = dt.getMinutes();
        minutes = minutes == 0 ? "00" : minutes;
        if (minutes != "00" && parseInt(minutes) < 10) {
          minutes = "0" + minutes;
        }
        dateString +=
          dt.getDate() +
          " " +
          monthNamesShort[dt.getMonth()] +
          " " +
          dt.getHours() +
          ":" +
          minutes;
        //return dt.toLocaleDateString();
      } catch (ex) {
        console.log(ex);
      }
      return dateString;
    },
    /* ,
    computed: {
      BannerURL() {
        // debugger;
        // var obj = JSON.parse(window.localStorage.getItem("my-app"));
        // return obj.branding[0].banner;
        //  db.collection("OA_UAT")
        //         .doc("ClientList")
        //         .collection("Clients")
        //         .where("CustomDomain", "==", this.result)
        //         .get()
        //         .then(querySnapshot => {
        //           querySnapshot.forEach(doc => {
        //           });
        //         });
      },
      pageBg() {
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        return obj.EventBranding[0].bg2;
      }
    }*/
  },
};
</script>
<style>
.no-reg-events {
  margin: 0 auto;
  text-align: center;
}
.no-reg-events h3 {
  font-weight: 700;
  font-size: 30px;
  color: #333;
  margin-bottom: 25px;
}
.no-reg-events a {
  display: inline-block;
  padding: 8px 30px;
  background: #00a982;
  color: #fff !important;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  border-radius: 5px;
  box-shadow: 0 5px 0 rgba(0, 0, 0, 0.5);
  margin-top: 15px;
}
.no-reg-events a:active {
  transform: translateY(5px);
  box-shadow: none;
}
.event-list-register-shimmer photo {
  display: block;
  width: 100%;
  height: 88px;
}
.shine {
  background: #f6f7f8;
  background-image: linear-gradient(
    to right,
    #f6f7f8 0%,
    #edeef1 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  background-repeat: no-repeat;
  background-size: 800px 100%;
  display: inline-block;
  position: relative;

  -webkit-animation-duration: 1s;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-name: placeholderShimmer;
  -webkit-animation-timing-function: linear;
}
.top-right-login.hdr-btn {
  padding: 0 0 15px;
}
.top-right-login.hdr-btn a.login,
.top-right-login.hdr-btn a.event-List {
  font-size: 18px;
  padding-right: 0 !important;
  margin-left: 25px;
  cursor: pointer;
  background-position: left center;
}
.left-logo.edu-banner {
  width: 100% !important;
}
.event-box-list-wrapper .ev-box {
  border-radius: 5px;
  cursor: pointer;
}
section.event-box-list-wrapper {
  margin-top: 25px;
}
@media only screen and (max-width: 767px) {
  /* .left-logo.edu-banner {
  display: none;
} */
  .left-logo.edu-banner a {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .left-logo.edu-banner a img {
    width: 100%;
    height: 100%;
  }
  .reg-event-banner {
    padding: 20px 0 !important;
    margin-top: 24px;
  }
  .edu-rage .reg-event-banner h1 {
    margin-top: 0;
  }
}
</style>